import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	background: ${colors.white};
	color: ${colors.grey7};
	display: flex;
	flex-direction: column;
	border-radius: 1px;
	position: relative;
	box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
	flex: 1;
	max-height: calc(100% - 50px);
`;

export const HorizontalLine = styled.div`
	position: absolute;
	right: 0;
	left: 0;
	top: 102px;
	height: 1px;
	background: ${colors.grey3};
`;

export const Title = styled.div`
	font-size: 19px;
	font-weight: 500;
	line-height: 27px;
	letter-spacing: 0px;
	margin-bottom: 25px;
`;

const cellStyle = css`
	display: flex;
	flex-direction: row;
	padding-right: 16px;
	justify-content: right;
	white-space: nowrap;

	&:first-child {
		justify-content: left;
		padding-right: 0;
	}
`;

export const TableCell = styled.div`
	color: ${colors.grey8};
	height: 36px;
	line-height: 19px;
	padding: 8px 0 9px 0;

	${cellStyle};
	align-items: flex-end;
	box-shadow: inset 0px 1px 0px ${colors.grey2};
	overflow: hidden;

	&:first-child {
		padding-left: 32px;
	}
`;

export const NameWrapper = styled.div`
	width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const HeaderNameWrapper = styled(NameWrapper)`
	width: calc(100% - 24px);
`;

export const WaveTableCell = styled(TableCell)`
	justify-content: center;
	align-items: center;
	padding-right: 0;
	border-left: 1px solid ${colors.grey2};
`;

export const TableHeaderCell = styled.div`
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0.3px;
	height: 36px;
	padding-top: 8px;
	color: ${colors.grey5};
	user-select: none;
	cursor: default;
	overflow: hidden;

	& > .ap-icon {
		margin: -4px -18px 0 2px;
	}

	&:first-child {
		padding-left: 32px;
		${NameWrapper};
	}

	${cellStyle};
`;

export const WaveTableHeaderCell = styled(TableHeaderCell)`
	padding-right: 0;
	justify-content: center;
	border-left: 1px solid ${colors.grey2};
	color: ${colors.grey7};
	button {
		display: none;
	}
	&:hover button {
		display: inline-flex;
		position: relative;
		top: -2px;
	}
	padding-bottom: 2px;
`;

export const AllocatedIcon = styled.div`
	width: 6px;
	height: 6px;
	background: ${colors.green1};
	border-radius: 100%;
	margin: 0 8px 0 -14px;
`;

export const TableRow = styled.div`
	display: contents;
	box-shadow: inset 0px 1px 0px ${colors.grey3};

	${AllocatedIcon} {
		visibility: hidden;
	}

	${({ isAllocated }) =>
		isAllocated
			? css`
					& ${TableCell} {
						background: ${colors.green0};
						align-items: center;
					}
					& ${AllocatedIcon} {
						visibility: visible;
					}
			  `
			: ''};

	${({ isHighlighted }) => {
		if (isHighlighted === null) {
			return '';
		}

		return isHighlighted
			? ''
			: css`
					& ${TableCell} {
						opacity: 0.3;
					}
			  `;
	}};

	${({ isHovered }) =>
		isHovered
			? css`
					& ${TableCell} {
						background: ${colors.grey1};
					}
			  `
			: ''};

	& ${TableHeaderCell}:nth-child(5),
	& ${TableCell}:nth-child(5) {
		padding-right: 34px;
	}
`;

export const TableFooter = styled.div`
	height: 56px;
	width: 100%;
	box-shadow: inset 0px 1px 0px ${colors.grey3};
	display: flex;
	align-items: center;
	padding-left: 32px;

	position: sticky;
	bottom: 0;
	z-index: 1;
	background: ${colors.white};
`;

export const Table = styled.div`
	font-size: 13px;
	position: relative;
	background: ${colors.white};
	z-index: 0;

	display: grid;

	${({ wavesLength }) =>
		wavesLength > 4
			? css`
					grid-template-columns: 1fr 84px 200px 100px 100px repeat(
							${wavesLength},
							44px
						);
			  `
			: css`
					grid-template-columns: 1fr 84px 200px 100px 100px repeat(
							${wavesLength},
							88px
						);
			  `};

	${({ stickyTop }) =>
		stickyTop
			? css`
					position: sticky;
					z-index: 1;
					top: 0;
			  `
			: ''};

	& + & {
		margin: 0;
	}
`;

export const TableScrollContainer = styled.div`
	position: relative;
	flex: 1;

	${({ noScroll }) =>
		noScroll
			? css`
					overflow: hidden;
			  `
			: css`
					overflow: auto;
			  `};
`;

export const FooterTotalsSummary = styled.div`
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
	margin-left: 24px;
`;

export const FooterTotalItem = styled.div`
	text-align: center;
`;

export const FooterTotals = styled(FooterTotalsSummary)`
	display: flex;
	margin-left: auto;
	${({ wavesLength }) =>
		wavesLength > 4
			? css`
					& ${FooterTotalItem} {
						width: 44px;
					}
			  `
			: css`
					& ${FooterTotalItem} {
						width: 88px;
					}
			  `};
`;
